var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgShareScreenIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99967 2.66602H27.9997C29.4663 2.66602 30.6663 3.86602 30.6663 5.33268V21.3327C30.6663 22.7994 29.4663 23.9993 27.9997 23.9993H18.6663V26.666H21.6663C22.2186 26.666 22.6663 27.1137 22.6663 27.666V28.3327C22.6663 28.885 22.2186 29.3327 21.6663 29.3327H10.333C9.78072 29.3327 9.33301 28.885 9.33301 28.3327V27.666C9.33301 27.1137 9.78072 26.666 10.333 26.666H13.333V23.9993H3.99967C2.53301 23.9993 1.33301 22.7994 1.33301 21.3327V5.33268C1.33301 3.86602 2.53301 2.66602 3.99967 2.66602ZM17.333 10.8393C12.1463 11.5593 10.0797 15.106 9.33301 18.666C11.1863 16.1727 13.6263 15.0393 17.333 15.0393V17.9593L22.6663 12.9727L17.333 7.99935V10.8393Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgShareScreenIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/share-screen-icon.dcafb3f5.svg";
export { ForwardRef as ReactComponent };